import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import ProfileFields from 'forms/merchant/profile/fields';
import Button from 'forms/shared/buttons';
import validate from './validator'
import AgreementFields from './agreement'

const ProfileForm = ({ handleSubmit, form, onUpdate, placesOptions = [], processing, type }) => (
  <form className="p-5" onSubmit={handleSubmit(values => onUpdate(values))}>
    {type === 'profile' && <ProfileFields form={form} placesOptions={placesOptions} />}
    {type === 'agreement' && <AgreementFields />}
    <Button
      buttonClassname={`rounded-lg w-full ${processing ? 'bg-form-disabled' : 'bg-primary-orange hover:bg-orange-400'} text-white py-2 px-10`} containerClassname={'text-center pt-5'}>
      {processing ? 'Saving...' : 'Save'}
    </Button>
  </form>
);

ProfileForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  form: PropTypes.string,
  onUpdate: PropTypes.func,
  placesOptions: PropTypes.array,
  processing: PropTypes.bool.isRequired,
  type: PropTypes.string
};

export default reduxForm({
  enableReinitialize: false,
  validate,
})(ProfileForm);
